import { IInputItems } from '@/typings';

export const condicaoClinica: IInputItems[] = [
  { label: 'A - Ausente', value: 'A' },
  { label: 'E - Extração Indicada', value: 'E' },
  { label: 'H - Hígido', value: 'H' },
  { label: 'C - Cariado', value: 'C' },
  { label: 'R - Restaurado', value: 'R' },
];
